module.exports = __webpack_public_path__ + "static/img/s139.d2f377ff.png";